export const CATEGORY_BOX = 'category-box';
export const CATEGORY_BOX_MOBILE_WIDTH = 120;
export const CATEGORY_BOX_DESKTOP_WIDTH = 160;
export const CATEGORY_BOX_MOBILE_MEDIUM_WIDTH = 160;
export const CATEGORY_BOX_DESKTOP_MEDIUM_WIDTH = 160;
export const CATEGORY_BOX_MOBILE_LARGE_WIDTH = 160;
export const CATEGORY_BOX_DESKTOP_LARGE_WIDTH = 240;
export const CATEGORY_BOX_IMAGE_MOBILE_HEIGHT = 180;
export const CATEGORY_BOX_IMAGE_DESKTOP_HEIGHT = 226;
export const CATEGORY_BOX_IMAGE_MOBILE_MEDIUM_HEIGHT = 226;
export const CATEGORY_BOX_IMAGE_DESKTOP_MEDIUM_HEIGHT = 226;
export const CATEGORY_BOX_IMAGE_MOBILE_LARGE_HEIGHT = 226;
export const CATEGORY_BOX_IMAGE_DESKTOP_LARGE_HEIGHT = 339;
//# sourceMappingURL=constants.js.map